import { render } from "./HairCare.vue?vue&type=template&id=16286e74"
import script from "./HairCare.vue?vue&type=script&lang=js"
export * from "./HairCare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__